<template>
  <div class="space-y-4">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div>
        <label :for="identifier('address-street')">
          {{ $t('constants.address.street') }}
        </label>
        <InputText
          :id="identifier('address-street')"
          class="w-full"
          data-test="address-street"
          :disabled="disabled"
          :modelValue="address_street"
          :readonly="is_read_only"
          @input="emit('edit')"
          @update:modelValue="(val) => emit('update:address_street', val)"
        />
      </div>
      <div>
        <label :for="identifier('address-number')">
          {{ $t('constants.address.number') }}
        </label>
        <InputText
          :id="identifier('address-number')"
          class="w-full"
          data-test="address-number"
          :disabled="disabled"
          :modelValue="address_number"
          :readonly="is_read_only"
          @input="emit('edit')"
          @update:modelValue="(val) => emit('update:address_number', val)"
        />
      </div>
    </div>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div>
        <label :for="identifier('address-zip')">
          {{ $t('constants.address.zip') }}
        </label>
        <InputText
          :id="identifier('address-zip')"
          class="w-full"
          data-test="address-zip"
          :disabled="disabled"
          :modelValue="address_zip"
          :readonly="is_read_only"
          @input="emit('edit')"
          @update:modelValue="(val) => emit('update:address_zip', val)"
        />
      </div>
      <div>
        <label :for="identifier('address-city')">
          {{ $t('constants.address.city') }}
        </label>
        <InputText
          :id="identifier('address-city')"
          class="w-full"
          data-test="address-city"
          :disabled="disabled"
          :modelValue="address_city"
          :readonly="is_read_only"
          @input="emit('edit')"
          @update:modelValue="(val) => emit('update:address_city', val)"
        />
      </div>
    </div>
    <SelectCountry
      class="w-full"
      :country_prop="address_country"
      :disabled="disabled"
      :is_read_only="is_read_only"
      :prefix="prefix"
      @change="emit('edit')"
      @input="(val) => emit('update:address_country', val)"
    />
  </div>
</template>

<script setup>
import { computed, watch } from 'vue';
import { useStore } from 'vuex';
import InputText from 'primevue/inputtext';
import SelectCountry from '@/app/shared_components/selects/SelectCountry.vue';

defineOptions({ name: 'AddressForm' });

const store = useStore();

const props = defineProps({
  address_city: { type: String, default: null },
  address_country: { type: String, default: null },
  address_number: { type: String, default: null },
  address_street: { type: String, default: null },
  address_zip: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  is_read_only: { type: Boolean, default: false },
  prefix: { type: String, default: '' },
});

const emit = defineEmits([
  'edit',
  'update:address_city',
  'update:address_country',
  'update:address_number',
  'update:address_zip',
  'update:address_street',
]);

const current_client = computed(() => store.getters.current_client);

const identifier = (field) => (_.isEmpty(field) ? field : `${props.prefix}-${field}`);

watch(
  current_client,
  (client_current) => {
    if (!client_current || props.address_country !== null) return;
    emit('update:address_country', client_current.attributes.address_country);
  },
  { immediate: true },
);
</script>
